import React from 'react'
import prmsteponeStyle from './PublisherRegisterMobilStepOne.module.css'

export default function PublisherRegisterMobilStepOne() {
  return (
    <>
      <div className={prmsteponeStyle.publishermobilsteponepage}>
        <div className='row'>
          <div className='col-7'>
            <h3> Welcome </h3>
          </div>
          <div className='col-5'>
            <div className={prmsteponeStyle.publisherprofileBox}>
              <div className={prmsteponeStyle.publisherprofileImg}>
                <div className={prmsteponeStyle.publisherprofileImginner}>
                  <img src="/static/media/lady-img.965cec88308ed5853d74.png" className="img-fluid w-100 h-100 rounded-circle" />
                </div>
              </div>
              <div className={prmsteponeStyle.publisherprofileeditBox}>
                <input type="file" className={prmsteponeStyle.publisherprofilechooseInput} accept=".png, .jpg, .jpeg" />
                <label className={prmsteponeStyle.publisherprofileLabel} for="imageUpload" />
              </div>
            </div>
          </div>
        </div>
        <h6> Sign up to join </h6>
        <h5> Publisher Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${prmsteponeStyle.publisheroneInput} form-control`} placeholder='First Name' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${prmsteponeStyle.publisheroneInput} form-control`} placeholder='Last Name' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${prmsteponeStyle.publisheroneInput} form-control`} placeholder='Name of Publisher' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="email" className={`${prmsteponeStyle.publisheroneInput} form-control`} placeholder='Email Address' />
            </div>
          </div>
          <div className='col-12'>
            <div className="mb-3">
              <input type="number" className={`${prmsteponeStyle.publisheroneInput} form-control`} placeholder='Phone Number' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
